import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 3h8a1 1 0 1 1 0 2h-.455v.907C17.001 6.897 18 8.571 18 10.841c0 3.372-2.657 6.16-6 6.16s-6-2.788-6-6.16c0-2.27 1.033-3.948 2.513-4.939V5H8a1 1 0 0 1 0-2m5.545 2h-3.031v2.074l-.535.28C8.855 7.946 8 9.074 8 10.842c0 2.327 1.82 4.16 4 4.16s4-1.833 4-4.16c0-1.796-.839-2.91-1.925-3.489l-.53-.282zM3.293 17.293a1 1 0 0 0 1.414 1.414L5.414 18A1 1 0 0 0 4 16.586zm16.935 0-.707-.707A1 1 0 0 0 18.106 18l.708.707a1 1 0 0 0 1.414-1.414M2 9a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm18 1a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1m-7 11a1 1 0 1 1-2 0v-1a1 1 0 0 1 2 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_flash-BrpdQe5V.js.map
